import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ForumPostBasicInfoComponent from './forum-post-basic-info.component';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';

export const ForumPostComponent = ({
    selectedForumPost, handleInnerFormChange, back, handleFormSubmit,forumTopics,onFormItemChange,id
}: any) => {
    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
    onFormItemChange({
      value: value.MediaFiles,
      field: 'MediaFiles',
      idx: '', //not used
    });
  };
    const tabItems = [
        {
            id: 1,
            title: 'Forum Post Basic Information',
            component: <ForumPostBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedForumPost={selectedForumPost}
                forumTopics={forumTopics}
            />,
            isVisible: true,
        },
         {
              id: 2,
              title: 'Media',
              component:
                <UploadMedia
                  handleInnerFormChange={handleInnerMediaFormChange}
                  mediaFilesList={selectedForumPost?.MediaMappings?.MediaFiles}
                  ownerTypeId={1025}
                  ownerId={id}
                  folderName={'forumpost'}
                />,
              isVisible: true,
            },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default ForumPostComponent;
